import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState, SavingDesignStatus } from '../types';

const setDesignSavingStatusReducer = (state: DesignState, action: PayloadAction<SavingDesignStatus>) => {
  state.designSavingStatus = action.payload;
};

export default setDesignSavingStatusReducer;
